<script>
export default {
  props: {
    classes: {
      type: String,
      default: 'pt-8 mb-10 flex border-b border-gray-light justify-between',
    },
    activeTab: {
      type: [Number, String],
      default: 0,
    },
    parentClasses: { default: '', type: String },
    tabClasses: {
      default: 'border-b-5 pb-5 text-xl cursor-pointer',
      type: String,
    },
  },
  data() {
    return {
      selectedIndex: 0, // the index of the selected tab,
      tabs: [], // all of the tabs
    }
  },
  created() {
    this.tabs = this.$children
  },
  mounted() {
    this.selectTab(parseInt(this.activeTab))
  },
  methods: {
    selectTab(i) {
      this.selectedIndex = i
      this.$emit('changed-tab', {
        index: i,
      })
      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i
      })
    },
  },
}
</script>

<template lang="html">
  <div>
    <div :class="parentClasses">
      <div :class="classes">
        <div
          v-for="(tab, index) in tabs"
          :key="tab.title"
          :class="[
            tabClasses,
            index === selectedIndex
              ? 'text-blue blue-default'
              : 'text-blue-darker border-transparent',
          ]"
          @click="selectTab(index)"
          v-html="tab.title"
        >
        </div>
      </div>
    </div>
    <div>
      <slot></slot>
    </div>
    <!-- <div
      v-for='(tab, index) in tabs'
      :key='tab.title'>
      <slot></slot>
    </div> -->
  </div>
</template>
